import React from "react";
import { SpadeEmblem } from "./SpadeEmblem";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-black py-10 border-t border-[#D4AF37]/20 relative"
        >
            <div
                className="absolute top-0 left-0 right-0 h-px"
                style={{
                    background:
                        "linear-gradient(90deg, transparent, rgba(212,175,55,0.6), transparent)",
                }}
            />
            <div className="max-w-5xl mx-auto px-6 flex flex-col items-center gap-4">
                <p className="text-sm text-white/60">
                    © casinobiat.online {new Date().getFullYear()}
                </p>
                <SpadeEmblem size={52} />
            </div>
        </footer>
    );
};
